export default __webpack_public_path__ + "static/media/10_Ausrstung vergessen.123863c6.png";